function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", {
  id: "genericDefs"
});

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", {
  id: "defs1"
}, /*#__PURE__*/React.createElement("clipPath", {
  clipPathUnits: "userSpaceOnUse",
  id: "clipPath1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0 L653 0 L653 425 L0 425 L0 0 Z"
})), /*#__PURE__*/React.createElement("clipPath", {
  clipPathUnits: "userSpaceOnUse",
  id: "clipPath2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M139 79 L792 79 L792 504 L139 504 L139 79 Z"
}))), /*#__PURE__*/React.createElement("g", {
  fill: "white",
  textRendering: "geometricPrecision",
  shapeRendering: "geometricPrecision",
  transform: "translate(-139,-79)",
  stroke: "white"
}, /*#__PURE__*/React.createElement("rect", {
  x: 139,
  width: 653,
  height: 425,
  y: 79,
  clipPath: "url(#clipPath2)",
  stroke: "none"
})), /*#__PURE__*/React.createElement("g", {
  textRendering: "geometricPrecision",
  strokeMiterlimit: 1.45,
  strokeWidth: 4,
  shapeRendering: "geometricPrecision",
  transform: "matrix(1,0,0,1,-139,-79)",
  strokeLinecap: "butt"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "none",
  x: 411,
  width: 109,
  height: 34,
  y: 311,
  clipPath: "url(#clipPath2)"
}), /*#__PURE__*/React.createElement("text", {
  x: 432.1309,
  y: 332.7139,
  clipPath: "url(#clipPath2)",
  fontFamily: "sans-serif",
  stroke: "none",
  fontWeight: "bold",
  strokeWidth: 1,
  xmlSpace: "preserve"
}, "3000004395")), /*#__PURE__*/React.createElement("g", {
  fill: "rgb(0,204,255)",
  textRendering: "geometricPrecision",
  shapeRendering: "geometricPrecision",
  transform: "matrix(1,0,0,1,-139,-79)",
  stroke: "rgb(0,204,255)"
}, /*#__PURE__*/React.createElement("ellipse", {
  rx: 88.5,
  ry: 17,
  clipPath: "url(#clipPath2)",
  cx: 688.5,
  cy: 328,
  stroke: "none"
})), /*#__PURE__*/React.createElement("g", {
  textRendering: "geometricPrecision",
  strokeMiterlimit: 1.45,
  shapeRendering: "geometricPrecision",
  transform: "matrix(1,0,0,1,-139,-79)",
  strokeLinecap: "butt"
}, /*#__PURE__*/React.createElement("ellipse", {
  rx: 88.5,
  fill: "none",
  ry: 17,
  clipPath: "url(#clipPath2)",
  cx: 688.5,
  cy: 328
}), /*#__PURE__*/React.createElement("text", {
  x: 632.1592,
  xmlSpace: "preserve",
  y: 332.7139,
  clipPath: "url(#clipPath2)",
  fontFamily: "sans-serif",
  stroke: "none"
}, "AC\xC9TAMINOPH\xC8NE")), /*#__PURE__*/React.createElement("g", {
  fill: "rgb(0,204,255)",
  textRendering: "geometricPrecision",
  shapeRendering: "geometricPrecision",
  transform: "matrix(1,0,0,1,-139,-79)",
  stroke: "rgb(0,204,255)"
}, /*#__PURE__*/React.createElement("ellipse", {
  rx: 88.5,
  ry: 17,
  clipPath: "url(#clipPath2)",
  cx: 688.5,
  cy: 256,
  stroke: "none"
})), /*#__PURE__*/React.createElement("g", {
  textRendering: "geometricPrecision",
  strokeMiterlimit: 1.45,
  shapeRendering: "geometricPrecision",
  transform: "matrix(1,0,0,1,-139,-79)",
  strokeLinecap: "butt"
}, /*#__PURE__*/React.createElement("ellipse", {
  rx: 88.5,
  fill: "none",
  ry: 17,
  clipPath: "url(#clipPath2)",
  cx: 688.5,
  cy: 256
}), /*#__PURE__*/React.createElement("text", {
  x: 643.1572,
  xmlSpace: "preserve",
  y: 260.7139,
  clipPath: "url(#clipPath2)",
  fontFamily: "sans-serif",
  stroke: "none"
}, "PARAC\xC9TAMOL")), /*#__PURE__*/React.createElement("g", {
  fill: "rgb(0,204,255)",
  textRendering: "geometricPrecision",
  shapeRendering: "geometricPrecision",
  transform: "matrix(1,0,0,1,-139,-79)",
  stroke: "rgb(0,204,255)"
}, /*#__PURE__*/React.createElement("ellipse", {
  rx: 88.5,
  ry: 17,
  clipPath: "url(#clipPath2)",
  cx: 688.5,
  cy: 400,
  stroke: "none"
})), /*#__PURE__*/React.createElement("g", {
  textRendering: "geometricPrecision",
  strokeMiterlimit: 1.45,
  shapeRendering: "geometricPrecision",
  transform: "matrix(1,0,0,1,-139,-79)",
  strokeLinecap: "butt"
}, /*#__PURE__*/React.createElement("ellipse", {
  rx: 88.5,
  fill: "none",
  ry: 17,
  clipPath: "url(#clipPath2)",
  cx: 688.5,
  cy: 400
}), /*#__PURE__*/React.createElement("text", {
  x: 613.4854,
  xmlSpace: "preserve",
  y: 404.7139,
  clipPath: "url(#clipPath2)",
  fontFamily: "sans-serif",
  stroke: "none"
}, "P-HYDROXYAC\xC9TANILIDE")), /*#__PURE__*/React.createElement("g", {
  fill: "rgb(0,204,255)",
  textRendering: "geometricPrecision",
  shapeRendering: "geometricPrecision",
  transform: "matrix(1,0,0,1,-139,-79)",
  stroke: "rgb(0,204,255)"
}, /*#__PURE__*/React.createElement("ellipse", {
  rx: 88.5,
  ry: 17,
  clipPath: "url(#clipPath2)",
  cx: 688.5,
  cy: 472,
  stroke: "none"
})), /*#__PURE__*/React.createElement("g", {
  textRendering: "geometricPrecision",
  strokeMiterlimit: 1.45,
  shapeRendering: "geometricPrecision",
  transform: "matrix(1,0,0,1,-139,-79)",
  strokeLinecap: "butt"
}, /*#__PURE__*/React.createElement("ellipse", {
  rx: 88.5,
  fill: "none",
  ry: 17,
  clipPath: "url(#clipPath2)",
  cx: 688.5,
  cy: 472
}), /*#__PURE__*/React.createElement("text", {
  x: 614.1504,
  xmlSpace: "preserve",
  y: 476.7139,
  clipPath: "url(#clipPath2)",
  fontFamily: "sans-serif",
  stroke: "none"
}, "4-HYDROXYAC\xC9TANILIDE")), /*#__PURE__*/React.createElement("g", {
  fill: "aqua",
  textRendering: "geometricPrecision",
  shapeRendering: "geometricPrecision",
  transform: "matrix(1,0,0,1,-139,-79)",
  stroke: "aqua"
}, /*#__PURE__*/React.createElement("ellipse", {
  rx: 88.5,
  ry: 17,
  clipPath: "url(#clipPath2)",
  cx: 242.5,
  cy: 328,
  stroke: "none"
})), /*#__PURE__*/React.createElement("g", {
  textRendering: "geometricPrecision",
  strokeMiterlimit: 1.45,
  shapeRendering: "geometricPrecision",
  transform: "matrix(1,0,0,1,-139,-79)",
  strokeLinecap: "butt"
}, /*#__PURE__*/React.createElement("ellipse", {
  rx: 88.5,
  fill: "none",
  ry: 17,
  clipPath: "url(#clipPath2)",
  cx: 242.5,
  cy: 328
}), /*#__PURE__*/React.createElement("text", {
  x: 190.1611,
  xmlSpace: "preserve",
  y: 332.7139,
  clipPath: "url(#clipPath2)",
  fontFamily: "sans-serif",
  stroke: "none"
}, "ACETAMINOPHEN")), /*#__PURE__*/React.createElement("g", {
  fill: "aqua",
  textRendering: "geometricPrecision",
  shapeRendering: "geometricPrecision",
  transform: "matrix(1,0,0,1,-139,-79)",
  stroke: "aqua"
}, /*#__PURE__*/React.createElement("ellipse", {
  rx: 88.5,
  ry: 17,
  clipPath: "url(#clipPath2)",
  cx: 242.5,
  cy: 400,
  stroke: "none"
})), /*#__PURE__*/React.createElement("g", {
  textRendering: "geometricPrecision",
  strokeMiterlimit: 1.45,
  shapeRendering: "geometricPrecision",
  transform: "matrix(1,0,0,1,-139,-79)",
  strokeLinecap: "butt"
}, /*#__PURE__*/React.createElement("ellipse", {
  rx: 88.5,
  fill: "none",
  ry: 17,
  clipPath: "url(#clipPath2)",
  cx: 242.5,
  cy: 400
}), /*#__PURE__*/React.createElement("text", {
  x: 169.4893,
  xmlSpace: "preserve",
  y: 404.7139,
  clipPath: "url(#clipPath2)",
  fontFamily: "sans-serif",
  stroke: "none"
}, "P-HYDROXY-ACETANILID")), /*#__PURE__*/React.createElement("g", {
  fill: "aqua",
  textRendering: "geometricPrecision",
  shapeRendering: "geometricPrecision",
  transform: "matrix(1,0,0,1,-139,-79)",
  stroke: "aqua"
}, /*#__PURE__*/React.createElement("ellipse", {
  rx: 88.5,
  ry: 17,
  clipPath: "url(#clipPath2)",
  cx: 242.5,
  cy: 472,
  stroke: "none"
})), /*#__PURE__*/React.createElement("g", {
  textRendering: "geometricPrecision",
  strokeMiterlimit: 1.45,
  shapeRendering: "geometricPrecision",
  transform: "matrix(1,0,0,1,-139,-79)",
  strokeLinecap: "butt"
}, /*#__PURE__*/React.createElement("ellipse", {
  rx: 88.5,
  fill: "none",
  ry: 17,
  clipPath: "url(#clipPath2)",
  cx: 242.5,
  cy: 472
}), /*#__PURE__*/React.createElement("text", {
  x: 167.0049,
  xmlSpace: "preserve",
  y: 476.7139,
  clipPath: "url(#clipPath2)",
  fontFamily: "sans-serif",
  stroke: "none"
}, "4'-HYDROXYACETANILIDE")), /*#__PURE__*/React.createElement("g", {
  fill: "aqua",
  textRendering: "geometricPrecision",
  shapeRendering: "geometricPrecision",
  transform: "matrix(1,0,0,1,-139,-79)",
  stroke: "aqua"
}, /*#__PURE__*/React.createElement("ellipse", {
  rx: 88.5,
  ry: 22,
  clipPath: "url(#clipPath2)",
  cx: 242.5,
  cy: 179,
  stroke: "none"
})), /*#__PURE__*/React.createElement("g", {
  textRendering: "geometricPrecision",
  strokeMiterlimit: 1.45,
  shapeRendering: "geometricPrecision",
  transform: "matrix(1,0,0,1,-139,-79)",
  strokeLinecap: "butt"
}, /*#__PURE__*/React.createElement("ellipse", {
  rx: 88.5,
  fill: "none",
  ry: 22,
  clipPath: "url(#clipPath2)",
  cx: 242.5,
  cy: 179
}), /*#__PURE__*/React.createElement("text", {
  x: 204.1621,
  xmlSpace: "preserve",
  y: 176.3633,
  clipPath: "url(#clipPath2)",
  fontFamily: "sans-serif",
  stroke: "none"
}, "ACETAMIDE, "), /*#__PURE__*/React.createElement("text", {
  x: 171.1592,
  xmlSpace: "preserve",
  y: 191.0645,
  clipPath: "url(#clipPath2)",
  fontFamily: "sans-serif",
  stroke: "none"
}, "N-(4-HYDROXYPHENYL)-")), /*#__PURE__*/React.createElement("g", {
  fill: "aqua",
  textRendering: "geometricPrecision",
  shapeRendering: "geometricPrecision",
  transform: "matrix(1,0,0,1,-139,-79)",
  stroke: "aqua"
}, /*#__PURE__*/React.createElement("ellipse", {
  rx: 88.5,
  ry: 17,
  clipPath: "url(#clipPath2)",
  cx: 242.5,
  cy: 256,
  stroke: "none"
})), /*#__PURE__*/React.createElement("g", {
  textRendering: "geometricPrecision",
  strokeMiterlimit: 1.45,
  shapeRendering: "geometricPrecision",
  transform: "matrix(1,0,0,1,-139,-79)",
  strokeLinecap: "butt"
}, /*#__PURE__*/React.createElement("ellipse", {
  rx: 88.5,
  fill: "none",
  ry: 17,
  clipPath: "url(#clipPath2)",
  cx: 242.5,
  cy: 256
}), /*#__PURE__*/React.createElement("text", {
  x: 197.1572,
  xmlSpace: "preserve",
  y: 260.7139,
  clipPath: "url(#clipPath2)",
  fontFamily: "sans-serif",
  stroke: "none"
}, "PARACETAMOL")), /*#__PURE__*/React.createElement("g", {
  fill: "rgb(0,204,255)",
  textRendering: "geometricPrecision",
  shapeRendering: "geometricPrecision",
  transform: "matrix(1,0,0,1,-139,-79)",
  stroke: "rgb(0,204,255)"
}, /*#__PURE__*/React.createElement("ellipse", {
  rx: 88.5,
  ry: 22,
  clipPath: "url(#clipPath2)",
  cx: 688.5,
  cy: 179,
  stroke: "none"
})), /*#__PURE__*/React.createElement("g", {
  textRendering: "geometricPrecision",
  strokeMiterlimit: 1.45,
  shapeRendering: "geometricPrecision",
  transform: "matrix(1,0,0,1,-139,-79)",
  strokeLinecap: "butt"
}, /*#__PURE__*/React.createElement("ellipse", {
  rx: 88.5,
  fill: "none",
  ry: 22,
  clipPath: "url(#clipPath2)",
  cx: 688.5,
  cy: 179
}), /*#__PURE__*/React.createElement("text", {
  x: 617.4902,
  xmlSpace: "preserve",
  y: 176.3633,
  clipPath: "url(#clipPath2)",
  fontFamily: "sans-serif",
  stroke: "none"
}, "N-(4-HYDROXYPH\xC9NYL) "), /*#__PURE__*/React.createElement("text", {
  x: 653.4961,
  xmlSpace: "preserve",
  y: 191.0645,
  clipPath: "url(#clipPath2)",
  fontFamily: "sans-serif",
  stroke: "none"
}, "AC\xC9TAMIDE"), /*#__PURE__*/React.createElement("text", {
  x: 213.6094,
  fontSize: "16px",
  y: 124.2852,
  clipPath: "url(#clipPath2)",
  fontFamily: "sans-serif",
  stroke: "none",
  fontWeight: "bold",
  xmlSpace: "preserve"
}, "English"), /*#__PURE__*/React.createElement("text", {
  x: 661.8281,
  fontSize: "16px",
  y: 117.2852,
  clipPath: "url(#clipPath2)",
  fontFamily: "sans-serif",
  stroke: "none",
  fontWeight: "bold",
  xmlSpace: "preserve"
}, "French"), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M520 328 L589 328",
  strokeWidth: 4,
  clipPath: "url(#clipPath2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M600 328 L583.5 321.125 L587.625 328 L583.5 334.875 Z",
  strokeWidth: 4,
  clipPath: "url(#clipPath2)",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M520 328 L591.8238 263.3586",
  strokeWidth: 4,
  clipPath: "url(#clipPath2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M600 256 L583.1365 261.9278 L590.8018 264.2784 L592.3348 272.1481 Z",
  strokeWidth: 4,
  clipPath: "url(#clipPath2)",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M520 328 L591.8238 392.6414",
  strokeWidth: 4,
  clipPath: "url(#clipPath2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M600 400 L592.3348 383.8519 L590.8018 391.7216 L583.1365 394.0722 Z",
  strokeWidth: 4,
  clipPath: "url(#clipPath2)",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M520 328 L594.6579 462.3843",
  strokeWidth: 4,
  clipPath: "url(#clipPath2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M600 472 L597.9967 454.2376 L593.9901 461.1823 L585.9771 460.9153 Z",
  strokeWidth: 4,
  clipPath: "url(#clipPath2)",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M410.9609 328 L342 328",
  strokeWidth: 4,
  clipPath: "url(#clipPath2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M331 328 L347.5 334.875 L343.375 328 L347.5 321.125 Z",
  strokeWidth: 4,
  clipPath: "url(#clipPath2)",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M410.9805 328.0176 L339.1762 392.6414",
  strokeWidth: 4,
  clipPath: "url(#clipPath2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M331 400 L347.8635 394.0722 L340.1983 391.7216 L338.6652 383.8519 Z",
  strokeWidth: 4,
  clipPath: "url(#clipPath2)",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M410.9805 328.0352 L336.3421 462.3843",
  strokeWidth: 4,
  clipPath: "url(#clipPath2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M331 472 L345.0229 460.9152 L337.0098 461.1823 L333.0033 454.2376 Z",
  strokeWidth: 4,
  clipPath: "url(#clipPath2)",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M410.9805 327.9636 L336.2035 188.6914",
  strokeWidth: 4,
  clipPath: "url(#clipPath2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M331 179 L332.748 196.7893 L336.8539 189.9029 L344.8623 190.285 Z",
  strokeWidth: 4,
  clipPath: "url(#clipPath2)",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M410.9805 327.9824 L339.1762 263.3586",
  strokeWidth: 4,
  clipPath: "url(#clipPath2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M331 256 L338.6652 272.1481 L340.1983 264.2784 L347.8635 261.9278 Z",
  strokeWidth: 4,
  clipPath: "url(#clipPath2)",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M520 328 L594.7966 188.6914",
  strokeWidth: 4,
  clipPath: "url(#clipPath2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M600 179 L586.1377 190.285 L594.1461 189.9029 L598.252 196.7893 Z",
  strokeWidth: 4,
  clipPath: "url(#clipPath2)",
  stroke: "none"
})));

function SvgExampleSubstanceEn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fillOpacity: 1,
    colorRendering: "auto",
    colorInterpolation: "auto",
    textRendering: "auto",
    stroke: "black",
    strokeLinecap: "square",
    width: 653,
    strokeMiterlimit: 10,
    shapeRendering: "auto",
    strokeOpacity: 1,
    fill: "black",
    strokeDasharray: "none",
    fontWeight: "normal",
    strokeWidth: 1,
    height: 425,
    fontFamily: "'Dialog'",
    fontStyle: "normal",
    strokeLinejoin: "miter",
    fontSize: "12px",
    strokeDashoffset: 0,
    imageRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExampleSubstanceEn);
export default __webpack_public_path__ + "static/media/ExampleSubstanceEN.3f109c6402a670b702e83b8084e481cc.svg";
export { ForwardRef as ReactComponent };